/**
 * Created by dorozco on 06/05/2019.
 */

import {Injectable} from '@angular/core';
import {TramitesResource} from './tramites.resource';
import {TramitesModel} from './tramites.model';
import {CategoriaModel} from '../../admin.categorias.module/service/categoria';

@Injectable()
export class TramitesService {
  constructor(private tramitesResource: TramitesResource) {
  }

  obtenerListaTramitesPorTipo(tipo: string): Promise<TramitesModel[]> {
    return this.tramitesResource.obtenerListaTramites({tipo: tipo});
  }
  listarTramites(tramitesFilterVM: any): Promise<TramitesModel[]> {
    return this.tramitesResource.listaTramites(tramitesFilterVM);
  }

  obtenerListaTramitesActivos(): Promise<TramitesModel[]> {
    return this.tramitesResource.obtenerListaTramitesActivos();
  }

  obtenerListaTramitesRCActivos(): Promise<TramitesModel[]> {
    return this.tramitesResource.obtenerListaTramitesRCActivos();
  }

  obtenerListaTramitesSTActivo(): Promise<TramitesModel[]> {
    return this.tramitesResource.obtenerListaTramitesSTActivos();
  }

  obtenerTramite(id: string): Promise<TramitesModel> {
    return this.tramitesResource.obtenerTramite({id: id});
  }

  obtenerTramitePorRuta(ruta: string): Promise<TramitesModel> {
    return this.tramitesResource.obtenerTramitePorRuta({path: ruta});
  }

  obtenerTramitesPorCategoria(categoriaId: string): Promise<TramitesModel[]> {
    return this.tramitesResource.obtenerTramitesPorCategoria({categoriaId: categoriaId});
  }

  insertarTramite(formalities: TramitesModel) {
    return this.tramitesResource.insertarTramite(formalities);
  }

  actualizarTramite(formalities: TramitesModel) {
    return this.tramitesResource.actualizarTramite(formalities);
  }

  obtenerCategoriasActivas(): Promise<CategoriaModel[]> {
    return this.tramitesResource.obtenerCategoriasActivas();
  }

  obtenerCategorias(): Promise<CategoriaModel[]> {
    return this.tramitesResource.obtenerCategorias();
  }

  obtenerTramitesPublic(s: any): Promise<TramitesModel[]> {
    return this.tramitesResource.obtenerTramitesPublic(s);
  }
}
